import React, { useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSongMap, updateSongMap } from '../../store/actions/playerActions'
import { Audio } from './audio/Audio'
import { Slices } from './slices/Slices'
import { useNavigate, useParams } from 'react-router-dom'
import { NotFound } from '../common/notFound/NotFound'
import { Centered } from '../common/centered/Centered'
import { PlaylistHeader } from './PlaylistHeader'

export const Player = () => {
    const dispatch = useDispatch()
    const { songMap, currentSource, currentTime, artist, title, isFetching, art } = useSelector(state => state.player)
    const audioRef = useRef()
    const params = useParams()
    const navigate = useNavigate()

    const loadSongMap = useCallback(async () => {
        try {
            await dispatch(getSongMap(params.artist, params.songTitle))
        } catch (e) {
            alert(e.code)
            navigate('/player')
        }
    }, [dispatch, params, getSongMap])

    useEffect(() => {
        loadSongMap()
    }, [loadSongMap])

    const handleClick = (slice) => {
        dispatch(updateSongMap(slice, audioRef.current.currentTime))
    }

    if (!isFetching && !artist) {
        return <Centered>
            <NotFound message='Cannot find this tune, dude...' />
        </Centered>
    }

    return <div>
        <PlaylistHeader 
            src={art}
            value={title} />
        {isFetching && <div>Fetching...</div>}
        <Audio ref={audioRef} source={currentSource} currentTime={currentTime} />
        <Slices songMap={songMap} handleClick={handleClick} />
    </div>
}